import { Box, CardHeader, Divider, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';
import Styles from '../../theme/commonCss/Styles';
import FormModal from '../../common/formModal';
import { userRoleActions } from '../../store/reducers/user-role';
import { palette } from '../../theme/palette';
import { get, reduce } from 'lodash';
import { addRoleSchema, addRoleUISchema } from './roleForm';
import { useState } from 'react';
import Ajv from 'ajv';
import AjvErrors from 'ajv-errors';
import { useOutletContext } from 'react-router-dom';

const AddRole = ({ isOpen, userRoleData, setUserRoleData, handleClose = () => {} }: any) => {
  const themeData: any = useTheme();
  const dispatch = useDispatch();
  const ajv = new Ajv({ allErrors: true });
  AjvErrors(ajv);
  const validate = ajv.compile(addRoleSchema);
  const [ajvErrors, setAjvErrors] = useState<any>({});

  const responsiveSize = useMediaQuery('(max-width:900px)');

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setUserRoleData({ ...userRoleData, [name]: value.trim() });
  };

  const handleFormClose = () => {
    handleClose();
    setAjvErrors({});
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    const trimmedUserData = reduce(
      userRoleData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );

    setUserRoleData(trimmedUserData);
    if (validate({ ...trimmedUserData })) {
      dispatch(userRoleActions.addRoleRequest(trimmedUserData));
      handleClose();
      setAjvErrors({});
    } else {
      if (validate.errors) {
        setAjvErrors(validate.errors[0]);
      }
    }
  };

  const renderFields = () => (
    <Grid container spacing={2} sx={{ ...Styles.gridContainer, flexDirection: 'column', marginLeft: 0 }}>
      {addRoleUISchema.map(({ label, name, type, options, required }: any) => {
        if (type === 'input') {
          return (
            <Grid container key={name} sx={{ display: 'flex', alignItems: 'center', marginBlock: '12px' }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                sx={{
                  display:'flex',
                  pb: responsiveSize ? '4px' : 0,
                  justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                }}
              >
                <Typography
                  sx={{ ...Styles.inputLabel, color: themeData.palette.text.primary, pb: get(ajvErrors, 'instancePath', '').includes(name) ? '20px' : '0' }}
                  className={required ? 'required-field' : ''}
                >
                  {label}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={8}>
                <TextField
                  margin='normal'
                  fullWidth
                  id={name}
                  onChange={handleChange}
                  name={name}
                  autoComplete={name}
                  variant='outlined'
                  value={userRoleData[name]}
                  size='small'
                  sx={{ margin: 0 }}
                  helperText={get(ajvErrors, 'instancePath', '').includes(name) && ajvErrors.message}
                  error={get(ajvErrors, 'instancePath', '').includes(name)}
                />
              </Grid>
            </Grid>
          );
        } else {
          return <></>;
        }
      })}
    </Grid>
  );

  return (
    <FormModal title='ADD NEW USER ROLE' isOpen={isOpen} handleSubmit={handleSubmit} handleClose={handleFormClose}>
      <CardHeader title='User Role Details' titleTypographyProps={Styles.title}/>
      <Divider/>
      {renderFields()}
    </FormModal>
  );
};

export default AddRole;